module.exports = __webpack_public_path__ + "img/settings_1280.bb650fa3.webp";